import { date } from "../core/date";
import { buildDateTimeString } from "../core/dateTime";
import { observable } from "../core/kendo";
import { schemas } from "./schemas";

export var ScreenObservable = function<T=void> () {
    this.displayObservable = observable<T>();
    this.requestObservable = observable<T>();
    this.ignoreChanges = [];
    this.ignoreChangeForUpdate = [];
    this.fieldsIgnored = [];
    this.saveButtonSelector = "";
};

ScreenObservable.prototype = {
    setObservable: function<T> (object:T, objectType: string) {
        var me = this;
        me.observableType = objectType;

        me.displayObservable = observable(object);
        me._initializeRequestObservable(object);

        var observableHandler = function (e) {
            if (me.ignoreChanges.indexOf(e.field) != -1) {
                return;
            }

            for (var x = 0; x < me.fieldsIgnored; x++) {
                var field = me.fieldsIgnored[x];
                if (e.field == field) {
                    return;
                }
            }

            me._buildObject(e);

            var getValue;
            if (e.value === "" || e.value === 0) {
                getValue = e.value;
            } else {
                getValue = e.value || me.displayObservable.get(e.field);
            }

            var lastIndexOfId = e.field.lastIndexOf("Id");

            me.ignoreChanges.push(e.field);

            if (lastIndexOfId == e.field.length - 2 && getValue && getValue.Id) {
                getValue = getValue.Id;
                me.displayObservable.set(e.field, getValue);
            }

            if (lastIndexOfId != -1 && (getValue == -1 || $.type(getValue) != "number")) {
                getValue = null;
                me.displayObservable.set(e.field, null);
            }

            if (me.ignoreChangeForUpdate.indexOf(e.field) == -1) {
                me.requestObservable.set($.trim(e.field), getValue);

                if (me.saveButton) {
                    me.saveButton.enable();
                }
            }

            var index = me.ignoreChanges.indexOf(e.field);
            me.ignoreChanges.splice(index, 1);
        };

        me.displayObservable.bind("set", observableHandler);
        me.displayObservable.bind("change", observableHandler);

        var requestObservableHandler = function (e) {
            if (me.ignoreChangeForUpdate.indexOf(e.field) == -1) {
                if (me.saveButton) {
                    me.saveButton.enable();
                }
                me.requestObservable.dirty = true;
            } else {
                me.displayObservable[e.field] = undefined;
            }
        };

        me.requestObservable.bind("set", requestObservableHandler);
        me.requestObservable.bind("change", requestObservableHandler);
    },
    _initializeRequestObservable: function (object) {
        var me = this;

        me.requestObservable = observable({
            Id: object.Id
        });

        if (object.Id) {
            return;
        }

        var properties = Object.keys(object);
        $.each(properties, function (index, property) {
            var value = object[property];
            if (me._shouldInitializeRequestObservableProperty(value)) {
                me.requestObservable.set(property, value);
            }
        });
    },
    _shouldInitializeRequestObservableProperty: function (value) {
        if (value === undefined) {
            return false;
        }

        if ($.isArray(value) && value.length == 0) {
            return false;
        }

        if ($.isPlainObject(value) && $.isEmptyObject(value)) {
            return false;
        }

        return true;
    },
    _buildObject: function (e) {
        var me = this;

        var keys = e.field.split(".");
        var object = me.displayObservable;
        var startIndex;
        var index;
        var length;
        var propertyName;

        if (keys[0].indexOf("[") == -1) {
            if (me.requestObservable && me.requestObservable[keys[0]]) {
                me.requestObservable[keys[0]] = me.displayObservable[keys[0]];
            } else if (me.displayObservable[keys[0]] && me.displayObservable[keys[0]].Id) {
                me.requestObservable[keys[0]] = { Id: me.displayObservable[keys[0]].Id };
            } else {
                me.requestObservable[keys[0]] = me.displayObservable[keys[0]] === undefined ? {} : me.displayObservable[keys[0]];
            }

            object = me.requestObservable[keys[0]];
        } else {
            startIndex = keys[0].indexOf("[");
            index = keys[0].substr(startIndex + 1);
            length = index.length - 1;
            index = index.substr(0, length) - 0;
            propertyName = keys[0].substr(0, startIndex);
            if (!me.requestObservable[propertyName] || JSON.stringify(me.requestObservable[propertyName]) == "{}") {
                me.requestObservable[propertyName] = me.requestObservable[propertyName] || [];
            }

            if (!me.requestObservable[propertyName][index]) {
                for (let ii = 0; ii < index; ii++) {
                    me.requestObservable[propertyName].push(null);
                }

                var setter = {};

                if (me.displayObservable[propertyName][index]) {
                    setter = { Id: me.displayObservable[propertyName][index].Id };
                }

                me.requestObservable[propertyName][index] = me.requestObservable[propertyName][index] || setter;
            }
            object = me.requestObservable[propertyName][index];
        }

        for (let ii = 1; ii < keys.length; ii++) {
            var schemaName = $.trim(e.field.split("[")[0].split(".")[ii - 1]),
                tempObject,
                schema = schemas[schemaName],
                val;
            if (schema) {
                val = schema.NavigationProperties[keys[ii]] || schema.Properties[keys[ii]];
            } else {
                var recursionCounter = ii,
                    parentSchema;
                while (!schema) {
                    if (recursionCounter < 0) {
                        break;
                    } else if (recursionCounter == ii) {
                        parentSchema = schemas[me.observableType];
                    } else {
                        parentSchema = schemas[keys[recursionCounter]];
                    }

                    if (!parentSchema) {
                        var realSchemaName = "",
                            realSchemaObject = schemas[me.observableType],
                            split = e.field.split("."),
                            realEntityName = "";

                        if (realSchemaObject) {
                            for (var iii = 0; iii < recursionCounter; iii++) {
                                var schemaDrill = realSchemaObject.NavigationProperties[split[iii]] || realSchemaObject.NavigationProperties[realEntityName],
                                    type = schemaDrill.Type;

                                realSchemaObject = schemas[type];
                                realSchemaName = type;
                            }
                        }

                        parentSchema = realSchemaObject;
                        schemaName = realSchemaName;
                    }

                    if (parentSchema) {
                        schema = parentSchema[schemaName];
                        val = parentSchema.NavigationProperties[keys[ii]] || parentSchema.Properties[keys[ii]];
                    }
                    recursionCounter--;
                }
            }

            var valType = val ? val.Type : "";
            var isEntity = schemas[valType] != undefined;
            if (keys[ii].indexOf("[") == -1) {

                if (isEntity) {
                    tempObject = { Id: object.Id };
                }

                object[keys[ii]] = object[keys[ii]] != null ? object[keys[ii]] : tempObject;
                object = object[keys[ii]];
            } else {
                startIndex = keys[ii].indexOf("[");
                index = keys[ii].substr(startIndex + 1);
                length = index.length - 1;
                index = index.substr(0, length);
                propertyName = keys[ii].substr(0, startIndex);
                if (!object[propertyName]) {
                    object[propertyName] = object[propertyName] || [];
                }

                if (!object[propertyName][index]) {
                    for (var j = 0; j < index; j++) {
                        me.requestObservable[propertyName].push(null);
                    }

                    if (isEntity) {
                        tempObject = { Id: object.Id };
                    }

                    object[propertyName][index] = object[propertyName][index] || tempObject;
                }
                object = object[propertyName][index];
            }
        }
    },
    bind: function (event, func) {
        return this.displayObservable.bind(event, func);
    },
    get: function (property) {
        return this.displayObservable.get(property);
    },
    set: function (property, value) {
        return this.displayObservable.set(property, value);
    },
    parent: function () {
        return this.displayObservable.parent();
    },
    toJSON: function () {
        return this.displayObservable.toJSON();
    },
    cleanObservable: function (args) {
        args = args || {};
        var cleanWithDto = args.cleanWithDto || null;
        var me = this;

        if (cleanWithDto) {
            var parsedObservable = $.parseJSON(JSON.stringify(me.requestObservable));
            if (Object.keys(parsedObservable).length == Object.keys(cleanWithDto).length) {
                me.requestObservable.zClean();
            }

            var keys = Object.keys(cleanWithDto);

            $.each(keys, function (index, key) {
                if (key != "_events" &&
                    key != "_handlers" &&
                    key != "Id" &&
                    key != "dirty" &&
                    key != "uid" &&
                    key != "zClean") {
                    if (JSON.stringify(cleanWithDto[key]) === JSON.stringify(me.requestObservable[key])) {
                        delete me.requestObservable[key];
                    } else {
                        me.requestObservable.dirty = true;
                    }
                }
            });

            if (me.saveButton && !args.autosave && !me.requestObservable.dirty) {
                me.saveButton.disable();
            }

        } else {
            me.requestObservable.zClean();

            keys = Object.keys(me.requestObservable);

            $.each(keys, function (index, key) {
                if (key != "_events" &&
                    key != "_handlers" &&
                    key != "Id" &&
                    key != "dirty" &&
                    key != "uid" &&
                    key != "zClean") {
                    delete me.requestObservable[key];
                }
            });

            if (me.saveButton && !args.autosave) {
                me.saveButton.disable();
            }
        }
    },
    addIgnoreChangeForUpdate: function (field) {
        var me = this;
        me.ignoreChangeForUpdate.push(field);
    },
    removeIgnoreChangeForUpdate: function (field) {
        var me = this,
            index = me.ignoreChangeForUpdate.indexOf(field);

        me.ignoreChangeForUpdate.splice(index, 1);
    }
};
